import { Api } from '../../../common/api/api'
import {
  ICheckinAPIModel, IClubAPIModel,
  ICourtsAPICreateFormModel,
  ICourtsAPIModel, IEntityCountAPIModel, IEventAPIModel, IPagedAPIViewModel,
  IReviewAPIModel
} from '../../../common/api/api-models'

export default class CourtsApiGateway extends Api {
  async getNearbyCourts (lat: number, lng: number, search?: string, radius = 300): Promise<ICourtsAPIModel[]> {
    if (search === undefined || search?.length === 0) {
      return this.get<any>('/courts/nearby', { lat, lng, radius })
    } else {
      return this.get<any>('/courts/search', { lat, lng, radius, search_text: search })
    }
  }

  async loadCourtsForClub (clubId: string): Promise<IClubAPIModel[]> {
    return this.get(`/courts/${clubId}/clubs`)
  }

  async loadCourt (courtId: string): Promise<ICourtsAPIModel> {
    return this.get<ICourtsAPIModel>(`/courts/${courtId}`)
  }

  async createCourt (form: ICourtsAPICreateFormModel): Promise<ICourtsAPIModel> {
    return this.post<ICourtsAPIModel>('/courts', form)
  }

  async updateCourt (courtId: string, form: ICourtsAPICreateFormModel): Promise<ICourtsAPIModel> {
    return this.put(`/courts/${courtId}`, form)
  }


  async getCourtReviews (courtId: string): Promise<IReviewAPIModel[]> {
    return this.get<IReviewAPIModel[]>(`/courts/${courtId}/reviews`)
  }

  async getCourtCheckins (courtId: string): Promise<ICheckinAPIModel[]> {
    return this.get<ICheckinAPIModel[]>(`/courts/${courtId}/checkins`)
  }

  async getCourtEvents (courtId: string, page: number): Promise<IPagedAPIViewModel<IEventAPIModel>> {
    return this.get(`/courts/${courtId}/events`, { page })
  }

  async getEntityCounts (lat: number, lng: number, radius: number): Promise<IEntityCountAPIModel> {
    return this.get('/clubs/entity_counts', { lat, lng, radius })
  }

  async getFavoriteLink (courtId: string): Promise<{url: string}> {
    return this.get(`/courts/${courtId}/favorite_link`)
  }

  async getViewLInk (courtId: string): Promise<{url: string}> {
    return this.get(`/courts/${courtId}/view_link`)
  }
}
